// Effect Managers
import { put, select, call } from 'redux-saga/effects'

// Exports
export default function composeHandleUpdate ({
  actionCreators,
  url,
  token$,
  handleFetch,
}) {
  return function *handleUpdate ({
    url: maybeUrl,
    queryParams,
    id: maybeId,
    data: maybeData,
    model: body = maybeData,
  }, {
    requestId = null,
    encode = true,
    reduce = true,
  } = {}) {
    if (maybeData) {
      console.warn(
        'Dispatching a create or update action using "data" is deprecating.' +
        ' Please use "model" instead.'
      )
    }

    const id = maybeId || body.id
    const token = yield select(token$)

    const options = yield {
      url: maybeUrl || url,
      token,
      queryParams,
      id,
      body,
      method: 'PUT',
      encode,
    }

    yield put(actionCreators.updating({
      queryParams,
      id,
      model: body,
    }, {
      meta: { requestId },
    }))

    const { bad, status, data, model, response } = yield call(handleFetch, options)

    if (bad) {
      yield put(actionCreators.failUpdate({
        id,
        queryParams,
        response,
        status,
        model: body,
      }, {
        meta: { requestId },
      }))
    } else {
      yield put(actionCreators.updated({
        id,
        queryParams,
        model,
        status,
      }, {
        meta: { requestId },
      }))

      if (reduce) {
        yield put(actionCreators.receive({
          id,
          queryParams,
          data,
        }, {
          meta: { requestId },
        }))
      }
    }

    return { status, response, data, model, error: bad }
  }
}
